import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const notyf = new Notyf({ duration: 7000, position: { x: 'right', y: 'bottom' } });

const userInfo=JSON.parse(localStorage.getItem('user'));

export const fetchMaintenanceTasks = createAsyncThunk('maintenanceTasks/fetchMaintenanceTasks', async (token) => {
    try {
        const url=(userInfo.role==="technicien" || userInfo.role==="ingenieur")?
            `${process.env.REACT_APP_API_URL}/api/auth/allForT`
            :
            `${process.env.REACT_APP_API_URL}/api/auth/getAllMaintenancesTasks`;
            const methode={
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            };
        const response = await fetch(url,methode);
        const result = await response.json();
        notyf.success('Maintenance tasks loaded successfully.');
        return result.allMaintenancesBack;
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});

export const addMaintenanceTasks = createAsyncThunk('maintenanceTasks/addMaintenanceTasks', async ({token,selectedRowM}) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/addMaintenance`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ id: selectedRowM?.id }),
        });

        const result = await response.json();
        notyf.success('Maintenance tasks loaded successfully.');
        return result.allMaintenancesBack;
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});

export const deleteMaintenanceTasks = createAsyncThunk('maintenanceTasks/deleteMaintenanceTasks', async ({token,selectedRowM}) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/deleteMaintenance`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ id: selectedRowM?.id }),
        }); 

        const result = await response.json();
        notyf.success('Maintenance tasks loaded successfully.');
        return result.allMaintenancesBack;
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});

export const updateMaintenanceTasks = createAsyncThunk('maintenanceTasks/updateMaintenanceTasks', async ({token,selectedRowM}) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/maintenances`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(selectedRowM),
        });

        const result = await response.json();
        ;
        return notyf.success(result.message);
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});


//!fetch actions:
const maintenanceTasksSlice = createSlice({
    name: 'maintenanceTasks',
    initialState: {
        maintenanceTasks: null,
        status: 'idle',
        error: null, 
        statusAdd: 'idle',
        error: null,   
        errorAdd: null,  
        statusDelete: 'idle',
        errorDelete: null,  
        statusUpdate: 'idle',
        errorUpdate: null,    
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMaintenanceTasks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMaintenanceTasks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.maintenanceTasks = action.payload;
            })
            .addCase(fetchMaintenanceTasks.rejected, (state, action) => {
                state.status = 'failed';
                state.errorAdd = action.error.message;
            })
            .addCase(addMaintenanceTasks.pending, (state) => {
                state.statusAdd = 'loading';
            })
            .addCase(addMaintenanceTasks.fulfilled, (state, action) => {
                state.statusAdd = 'succeeded';
            })
            .addCase(addMaintenanceTasks.rejected, (state, action) => {
                state.statusAdd = 'failed';
                state.errorAdd = action.error.message;
            })
            .addCase(deleteMaintenanceTasks.pending, (state) => {
                state.statusDelete = 'loading';
            })
            .addCase(deleteMaintenanceTasks.fulfilled, (state, action) => {
                state.statusDelete = 'succeeded';
            })
            .addCase(deleteMaintenanceTasks.rejected, (state, action) => {
                state.statusDelete = 'failed';
                state.errorDelete = action.error.message;
            })
            .addCase(updateMaintenanceTasks.pending, (state) => {
                state.statusUpdate = 'loading';
            })
            .addCase(updateMaintenanceTasks.fulfilled, (state, action) => {
                state.statusUpdate = 'succeeded';
            })
            .addCase(updateMaintenanceTasks.rejected, (state, action) => {
                state.statusUpdate = 'failed';
                state.errorUpdate = action.error.message;
            })
    },
});
export const maintenanceTasksReducer= maintenanceTasksSlice.reducer;
